webpackJsonp([39732927749384],{

/***/ 1208:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/frame-mock.7943d425.png";

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss.6a38c5c2.png";

/***/ }),

/***/ 1209:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss2.34407c5a.png";

/***/ }),

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ss3.131b5507.png";

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImages = __webpack_require__(112);
	
	var _reactImages2 = _interopRequireDefault(_reactImages);
	
	var _gallery = __webpack_require__(136);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tstPage = function tstPage(_ref) {
	    var children = _ref.children,
	        location = _ref.location;
	
	    var mockImg = __webpack_require__(1208);
	    var screenshots = [{ src: __webpack_require__(288) }, { src: __webpack_require__(1209) }, { src: __webpack_require__(1210) }];
	    return _react2.default.createElement(
	        'div',
	        { className: 'portofolio-project-wrapper ' },
	        _react2.default.createElement(
	            'div',
	            { className: 'portofolio-project tst ' },
	            _react2.default.createElement(
	                'h1',
	                null,
	                ' Tvshowtrack'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-subtitle' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-status' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'Status: '
	                    ),
	                    ' Completed'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-link' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'http://www.tvshowtrack.com', target: '_blank' },
	                        'View Application'
	                    )
	                )
	            ),
	            _react2.default.createElement('img', { src: mockImg, alt: 'tst Screenshots' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-intro' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Introduction'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'A basic TV series tracker. Allows users to see various details about their favourite TV Shows.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-tags' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#AngularJS'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#Flask'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        '#Heroku'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-features' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Achievements'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Server-side rendering with Angular Universal'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Using the ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://www.tvmaze.com/api', target: '_blank' },
	                            'TV Maze API'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Using cron functions to periodically fetch Tv Series data'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('i', { className: 'fa fa-check' }),
	                        'Deployed to Digital Ocean using a custom domain '
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'project-section project-screenshots' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Screenshots'
	                ),
	                _react2.default.createElement(_gallery2.default, { images: screenshots })
	            )
	        )
	    );
	};
	
	exports.default = tstPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portofolio-tst-js-0f13601c2ffff8ade290.js